import React, { useState, useEffect } from 'react';
import StyledBox from 'views/information-module/InternationalView/InternationalView.styles';
import { useTranslation } from 'next-i18next';
import {
  FranchiseCommonSections,
  StyledFranchiseTitleWithDesc,
} from 'views/information-module/common/components';
import { Box } from '@mui/material';
import axios, { API } from 'lib/config/axios';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';

const inquiryLink = 'https://docs.google.com/forms/d/1AF2DrjrnVam5RqxBqlETEnOt9btUjTY_sMN38LRnVpA/viewform?edit_requested=true';

const InternationalView = (props) => {
  const { t } = useTranslation('fe_er_international_page');
  const handleErrorResponse = useErrorsHandler();
  const { serverData } = props;
  const [seoValues, setSeoValues] = useState(serverData);
  const getSeoValuesData = () => {
    axios
      .get(API.seoValues)
      .then((res) => {
        setSeoValues(res.data);
      })
      .catch((error) => {
        handleErrorResponse(error, false);
      });
  };

  const rebrandingImage = {
    src: '/imgs/franchise/international.jpg',
    alt: t('fe_er_international_page:header'),
  };
  const verticaltabs = [
    {
      label: t('fe_er_international_page:about_header'),
      value: 1,
      href: '#about',
    },
    {
      label: t('fe_er_international_page:support_header'),
      value: 2,
      href: '#support',
    },
    {
      label: t('fe_er_international_page:requirments_header'),
      value: 3,
      href: '#requirments',
    },
  ];

  const activeTab = 7;
  useEffect(() => {
    if (!serverData) {
      getSeoValuesData();
    }
  }, []);
  return (
    <>
      <Head>{seoValues && generateMetaData(seoValues)}</Head>
      <StyledBox>
        <FranchiseCommonSections
          activeTab={activeTab}
          verticaltabs={verticaltabs}
          titleWithImage={rebrandingImage}
          titleWithImgText={t('fe_er_international_page:header')}>
          <Box className="IVAbout" id="about">
            <StyledFranchiseTitleWithDesc
              titleVariant="h3"
              component="h2"
              title={t('fe_er_international_page:about_header')}
              description={t('fe_er_international_page:about_text')}
            />
          </Box>
          <Box mb={2} mt={{ lg: 11, md: 8, sm: 6 }} id="support">
            <StyledFranchiseTitleWithDesc
              titleVariant="h3"
              component="h2"
              title={t('fe_er_international_page:support_header')}
              description={t('fe_er_international_page:support_text')}
            />
          </Box>
          <Box mt={{ lg: 11, md: 8, sm: 6 }} mb={5} id="requirments">
            <StyledFranchiseTitleWithDesc
              titleVariant="h3"
              component="h2"
              title={t('fe_er_international_page:requirments_header')}
              description={t('fe_er_international_page:requirments_text', {
                inquiry_link: inquiryLink,
              })}
            />
          </Box>
        </FranchiseCommonSections>
      </StyledBox>
    </>
  );
};

export { InternationalView };
